import React, { useState } from "react";
import { allChartData } from "narratives/constants";
import { getNarrativeMilestones } from "utils/narratives";
import NarrativesPage from "components/NarrativesPage";
import { useRouter } from "next/router";
import {
  NARRATIVE_TYPES_ARRAY,
  getNarrativeSlug,
  getNarrativeBySlug,
} from "posts/constants";

export async function getStaticProps() {
  const chartData = allChartData();
  const narrativeMilestones = getNarrativeMilestones();

  return {
    props: {
      chartData,
      narrativeMilestones,
      baseUrl: process.env.BASE_URL,
    },
  };
}

export async function getStaticPaths() {
  const slugs = [
    "compare",
    ...NARRATIVE_TYPES_ARRAY.map((narrativeType) =>
      getNarrativeSlug(narrativeType)
    ),
  ];

  return {
    paths: slugs.map((narrativeType) => ({
      params: { slug: narrativeType },
    })),
    fallback: false,
  };
}

export default function Narratives({ chartData, narrativeMilestones }) {
  const router = useRouter();
  const { slug } = router.query;
  const narrative = slug === "compare" ? null : getNarrativeBySlug(slug);

  return (
    <NarrativesPage
      chartData={chartData}
      narrativeMilestones={narrativeMilestones}
      narrative={narrative}
    />
  );
}
